var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"content":_vm.unreadCounter,"value":_vm.unreadCounter && _vm.show,"color":"#f44336","overlap":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }